import { render, staticRenderFns } from "./SidebarAddNewAddress.vue?vue&type=template&id=6c3d92be&"
import script from "./SidebarAddNewAddress.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewAddress.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports